import { usePlatformTheme, type PlatformThemeMode } from '@/utils/platformTheme'
import styles from './Platform.module.css'

type Props = {
  compact?: boolean
}

export function PlatformThemeToggle({ compact = false }: Props) {
  const [mode, setMode] = usePlatformTheme()

  const pick = (next: PlatformThemeMode) => () => setMode(next)

  return (
    <div
      className={compact ? styles.themeToggleCompact : styles.themeToggle}
      role="group"
      aria-label="Tema do painel interno"
    >
      {!compact && <span className={styles.themeToggleLabel}>Tema</span>}
      <button
        type="button"
        className={`${styles.themeToggleBtn} ${mode === 'light' ? styles.themeToggleBtnActive : ''}`}
        onClick={pick('light')}
        aria-pressed={mode === 'light'}
      >
        Claro
      </button>
      <button
        type="button"
        className={`${styles.themeToggleBtn} ${mode === 'dark' ? styles.themeToggleBtnActive : ''}`}
        onClick={pick('dark')}
        aria-pressed={mode === 'dark'}
      >
        Escuro
      </button>
    </div>
  )
}
